import React, { useState } from 'react';
import { FileText, Eye, Trash2 } from 'lucide-react';
import AlertModal from '../../../components/ui/AlertModal';
import Tooltip from '../../../components/ui/Tooltip';

const EntityDocuments = ({ documents = [], onUpload, onDelete }) => {
  const [docToDelete, setDocToDelete] = useState(null);

  const handleDeleteConfirm = async () => {
    if (docToDelete && onDelete) {
      await onDelete(docToDelete);
    }
    setDocToDelete(null);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-primary">Liste des documents</h3>
        {onUpload && (
          <button onClick={onUpload} className="btn btn-primary text-sm">
            Ajouter
          </button>
        )}
      </div>
      {documents.length === 0 ? (
        <p className="text-sm text-tertiary italic">Aucun document pour le moment.</p>
      ) : (
        <ul className="divide-y divide-workspace">
          {documents.map((doc) => {
             const fileUrl = doc.fileUrl?.startsWith('http') 
               ? doc.fileUrl 
               : (doc.fileUrl?.startsWith('/') ? doc.fileUrl : `/${doc.fileUrl || ''}`);
             
             return (
            <li key={doc.id} className="py-3 flex justify-between items-center group">
              <div className="flex items-center">
                <FileText className="h-5 w-5 text-tertiary mr-3" />
                <div>
                  <p className="text-sm font-semibold text-primary">{doc.title}</p>
                  <p className="text-xs text-tertiary">{doc.type}</p>
                </div>
              </div>
              <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <Tooltip content="Visualiser">
                  <a 
                    href={fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="p-2 text-tertiary hover:text-primary hover:bg-surface-muted rounded-md transition-colors"
                  >
                    <Eye className="h-5 w-5" />
                  </a>
                </Tooltip>
                {onDelete && (
                  <Tooltip content="Supprimer">
                    <button 
                      onClick={() => setDocToDelete(doc.id)}
                      className="p-2 text-tertiary hover:text-danger-600 hover:bg-danger-50 rounded-md transition-colors"
                    >
                      <Trash2 className="h-5 w-5" />
                    </button>
                  </Tooltip>
                )}
              </div>
            </li>
          )})}
        </ul>
      )}

      <AlertModal
        isOpen={!!docToDelete}
        onClose={() => setDocToDelete(null)}
        onConfirm={handleDeleteConfirm}
        title="Supprimer le document"
        message="Êtes-vous sûr de vouloir supprimer ce document ? Cette action est irréversible."
        confirmText="Supprimer"
        cancelText="Annuler"
        type="danger"
      />
    </div>
  );
}

export default EntityDocuments;
